"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "LifeBuoy___StyledSvg",
  componentId: "sc-1pfwbcc-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function LifeBuoy(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M240 30C124.211 30 30 124.237 30 240c0 115.815 94.211 210 210 210 115.815 0 210-94.185 210-210 0-115.763-94.185-210-210-210zm71.531 40.714l-20.448 48.352c-32.34-13.65-69.825-13.65-102.165 0l-20.45-48.352c45.335-19.189 97.73-19.189 143.063 0zM119.04 291.109l-48.353 20.475C61.107 288.904 56.25 264.806 56.25 240c0-24.806 4.856-48.851 14.437-71.531l48.353 20.475c-6.825 16.143-10.29 33.311-10.29 51.056 0 17.745 3.465 34.965 10.29 51.109zM240 423.75c-24.806 0-48.877-4.83-71.531-14.464l20.449-48.352c32.34 13.702 69.825 13.702 102.165 0l20.448 48.352c-22.68 9.634-46.725 14.464-71.531 14.464zm0-78.75c-57.907 0-105-47.066-105-105 0-57.881 47.093-105 105-105s105 47.119 105 105c0 57.934-47.093 105-105 105zm120.934-53.891c6.851-16.144 10.316-33.364 10.316-51.109 0-17.745-3.465-34.913-10.316-51.056l48.352-20.475c9.608 22.68 14.464 46.725 14.464 71.531 0 24.806-4.856 48.904-14.464 71.584l-48.352-20.475z"
  }));
}

var _default = LifeBuoy;
exports["default"] = _default;